import { SecurityRoleItems, TaskSecurityRoles } from "@shared/_enums/securityRoleItems";
import { RouteUrls } from "@shared/_enums/routeUrls";
import { NotificationType, TaskCategory, TaskIcons, Tasks } from "./enum";
import { NotificationsCount, NotificationTabConfig } from "./interface";

export interface taskConfig {
  ruleName: string;
  securityRoleKey: string;
  categoryTranslationKey?: string;
  taskHeading?: string;
  taskInstructions?: string;
  buttonTextForParentCategoryNavigation?: string;
  icon: string;
  iconAltTextKey: string;
  categoryDisplayOrder: number;
  displayOrder: number;
  viewTaskDetailTranslationKey: string;
}

export const taskconfig: taskConfig[] = [
  { ruleName: Tasks.JobsPendingApproval, securityRoleKey: TaskSecurityRoles.JobsPendingApproval, categoryTranslationKey: 'JobApprovalTitle', taskHeading: 'JobApprovalHeading', taskInstructions: 'JobApprovalInstructions', buttonTextForParentCategoryNavigation: 'JobApprovalButtonLabel', icon: TaskIcons.JobsPendingApproval, categoryDisplayOrder: 1, displayOrder: 1, iconAltTextKey: 'JobApprovalIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualJobWaitingApproval' },
  { ruleName: Tasks.ReviewApplications, securityRoleKey: TaskSecurityRoles.ReviewApplications, categoryTranslationKey: 'ApplicationsTitle', taskHeading: 'ApplicationsHeading', taskInstructions: 'ApplicationsInstructions', buttonTextForParentCategoryNavigation: 'NewApplicationsButtonLabel', icon: TaskIcons.ReviewApplications, categoryDisplayOrder: 2, displayOrder: 1, iconAltTextKey: 'ApplicationsIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualReviewApplication' },
  { ruleName: Tasks.ReviewAttractionStrategy, securityRoleKey: TaskSecurityRoles.ReviewAttractionStrategy, categoryTranslationKey: 'ApplicationsTitle', taskHeading: 'ReviewAttractionStrategyHeading', taskInstructions: 'ReviewAttractionStrategyInstructions', icon: TaskIcons.ReviewAttractionStrategy, categoryDisplayOrder: 2, displayOrder: 2, iconAltTextKey: 'AttractionStrategyIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualStrategyTask' },
  { ruleName: Tasks.ArrangeInterviews, securityRoleKey: TaskSecurityRoles.ArrangeInterviews, categoryTranslationKey: 'InterviewsTitle', taskHeading: 'ArrangeInterviewsHeading', taskInstructions: 'ArrangeInterviewsInstructions', buttonTextForParentCategoryNavigation: 'ArrangeInterviewsButtonLabel', icon: TaskIcons.ArrangeInterviews, categoryDisplayOrder: 3, displayOrder: 1, iconAltTextKey: 'ArrangeInterviewsIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualArrangeInterviews' },
  { ruleName: Tasks.RecordInterviewOutcomes, securityRoleKey: TaskSecurityRoles.RecordInterviewOutcomes, categoryTranslationKey: 'InterviewsTitle', taskHeading: 'RecordInterviewOutcomesHeading', taskInstructions: 'RecordInterviewOutcomesInstructions', buttonTextForParentCategoryNavigation: 'ArrangeInterviewsButtonLabel', icon: TaskIcons.RecordInterviewOutcomes, categoryDisplayOrder: 3, displayOrder: 2, iconAltTextKey: 'RecordInterviewIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualRecordInterview' },
  { ruleName: Tasks.UpcomingInterviews, securityRoleKey: TaskSecurityRoles.UpcomingIntervews, categoryTranslationKey: 'InterviewsTitle', taskHeading: 'UpcomingInterviewsHeading', taskInstructions: 'UpcomingInterviewsInstructions', icon: TaskIcons.UpcomingInterviews, categoryDisplayOrder: 3, displayOrder: 3, iconAltTextKey: 'UpcomingInterviewsIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualUpcomingInterviews' },
  { ruleName: Tasks.Offers, securityRoleKey: TaskSecurityRoles.OffersToPrepare, categoryTranslationKey: 'OffersToPrepareTitle', taskHeading: 'OffersToPrepareHeading', taskInstructions: 'OffersToPrepareInstructions', icon: TaskIcons.Offers, categoryDisplayOrder: 4, displayOrder: 1, iconAltTextKey: 'OffersToPrepareIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualOffersToPrepare' },
  { ruleName: Tasks.ReviewOnboarding, securityRoleKey: TaskSecurityRoles.ReviewOnboarding, categoryTranslationKey: 'OnboardingTitle', taskHeading: 'ReviewOnboardingHeading', taskInstructions: 'ChaseOnboardingInstructions', buttonTextForParentCategoryNavigation: 'OnboardingButtonLabel', icon: TaskIcons.ReviewOnboarding, categoryDisplayOrder: 5, displayOrder: 1, iconAltTextKey: 'ReviewOnboardingIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualReviewOnboarding' },
  { ruleName: Tasks.ChaseOnboarding, securityRoleKey: TaskSecurityRoles.ChaseOnboarding, categoryTranslationKey: 'OnboardingTitle', taskHeading: 'OnboardingHeading', taskInstructions: 'ChaseOnboardingInstructions', buttonTextForParentCategoryNavigation: 'OnboardingButtonLabel', icon: TaskIcons.ChaseOnboarding, categoryDisplayOrder: 5, displayOrder: 2, iconAltTextKey: 'ChaseOnboardingIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualChaseOnboarding' },
  { ruleName: Tasks.PrepareForNewStarter, securityRoleKey: TaskSecurityRoles.PrepForNewStarters, categoryTranslationKey: 'OnboardingTitle', taskHeading: 'NewStartersHeading', taskInstructions: 'NewStartersInstructions', icon: TaskIcons.PrepareForNewStarter, categoryDisplayOrder: 5, displayOrder: 3, iconAltTextKey: 'PrepareForNewStarterIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualNewStarter' },
  { ruleName: Tasks.ChaseGapConcern, securityRoleKey: TaskSecurityRoles.ChaseGapAndConcern, categoryTranslationKey: 'OnboardingTitle', taskHeading: 'ChaseGapAndConcernHeading', taskInstructions: 'ChaseGapAndConcernInstructions', icon: TaskIcons.ChaseGapConcern, categoryDisplayOrder: 5, displayOrder: 4, iconAltTextKey: 'ChaseGapConcernIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualChaseGapConcern' },
  { ruleName: Tasks.ReviewCompliance, securityRoleKey: TaskSecurityRoles.ReviewCompliance, categoryTranslationKey: 'ComplianceTitle', taskHeading: 'ReviewComplianceHeading', taskInstructions: 'ChaseComplianceInstructions', buttonTextForParentCategoryNavigation: 'ComplianceButtonLabel', icon: TaskIcons.ReviewCompliance, categoryDisplayOrder: 6, displayOrder: 1, iconAltTextKey: 'ReviewComplianceIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualReviewCompliance' },
  { ruleName: Tasks.ChaseCompliance, securityRoleKey: TaskSecurityRoles.ChaseCompliance, categoryTranslationKey: 'ComplianceTitle', taskHeading: 'ComplianceHeading', taskInstructions: 'ChaseComplianceInstructions', buttonTextForParentCategoryNavigation: 'ComplianceButtonLabel', icon: TaskIcons.ChaseCompliance, categoryDisplayOrder: 6, displayOrder: 2, iconAltTextKey: 'ChaseComplianceIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualChaseCompliance' },
  { ruleName: Tasks.ReviewReferences, securityRoleKey: TaskSecurityRoles.ReviewReferences, categoryTranslationKey: 'ReferencesTitle', taskHeading: 'ReviewReferencesHeading', taskInstructions: 'ReferencesToReviewInstructions', buttonTextForParentCategoryNavigation: 'ReferencesButtonLabel', icon: TaskIcons.ReviewReferences, categoryDisplayOrder: 7, displayOrder: 1, iconAltTextKey: 'ReferencesToReviewIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualReviewReferences' },
  { ruleName: Tasks.ChaseReference, securityRoleKey: TaskSecurityRoles.ChaseReferences, categoryTranslationKey: 'ReferencesTitle', taskHeading: 'ChaseReferenceHeading', taskInstructions: 'ChaseReferenceInstructions', buttonTextForParentCategoryNavigation: 'ReferencesButtonLabel', icon: TaskIcons.ChaseReference, categoryDisplayOrder: 7, displayOrder: 2, iconAltTextKey: 'ChaseReferenceIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualChaseReference' },
  { ruleName: Tasks.RequestFurtherReferences, securityRoleKey: TaskSecurityRoles.RequestFurtherReferences, categoryTranslationKey: 'ReferencesTitle', taskHeading: 'FurtherReferencesHeading', taskInstructions: 'FurtherReferencesInstructions', icon: TaskIcons.RequestFurtherReferences, categoryDisplayOrder: 7, displayOrder: 3, iconAltTextKey: 'RequestFurtherReferencesIconAltText', viewTaskDetailTranslationKey: 'ViewIndivisualFurtherReferences' },
];

export interface TaskNavigationConfig {
  categoryName: string;
  route?: string;
}

export const taskNavigationConfig: TaskNavigationConfig[] = [
  {
    categoryName: TaskCategory.JobsPendingApproval,
    route: RouteUrls.JobAuthorisations.List,
  },
  {
    categoryName: TaskCategory.Applications,
    route: RouteUrls.NewApplication.List,
  },
  {
    categoryName: TaskCategory.Interviews,
    route: RouteUrls.Calendar.List,
  },
  {
    categoryName: TaskCategory.Onboarding,
    route: RouteUrls.OnboardingHub.Onboarding,
  },
  {
    categoryName: TaskCategory.Compliance,
    route: RouteUrls.OnboardingHub.Compliance,
  },
  {
    categoryName: TaskCategory.References,
    route: RouteUrls.OnboardingHub.References,
  }
];

export interface IndividualTaskNavigationConfig {
  ruleName: string;
  route: string;
  staticParams?: Record<string, string | number>;
  dynamicParams?: string[];
  paramMappings?: Record<string, string>;
}

const candidateListTasks = [
  Tasks.ReviewApplications,
  Tasks.ReviewAttractionStrategy,
  Tasks.ArrangeInterviews,
  Tasks.RecordInterviewOutcomes,
  Tasks.UpcomingInterviews
];
const candidateDetailTask: (typeof Tasks[keyof typeof Tasks])[] = [
  Tasks.Offers,
  Tasks.ReviewReferences,
  Tasks.ChaseReference,
  Tasks.RequestFurtherReferences,
  Tasks.ChaseCompliance,
  Tasks.ChaseOnboarding,
  Tasks.ChaseGapConcern,
  Tasks.PrepareForNewStarter,
  Tasks.ReviewOnboarding,
  Tasks.ReviewCompliance
];

const candidateDetailRoute = RouteUrls.JobandTalent.CandidateList;
const candidateDetailDynamicParams = ['id', 'candidateDetail', 'candidateId'];
const candidateDetailParamMappings = {
  id: 'jobId',
  candidateDetail: 'candidateId',
};


const candidateListDynamicParams = ['id', 'applicationStatusIds'];
const candidateListParamMappings = {
  id: 'jobId',
  applicationStatusIds: 'applicationStatusId'
};

export const IndividualTaskNavigationConfig: IndividualTaskNavigationConfig[] = [
  { ruleName: Tasks.JobsPendingApproval, route: RouteUrls.AddJob.ApprovalForm, staticParams: { returnUrl: 12 }, dynamicParams: ['jobId'] },
  ...candidateListTasks.map(rule => ({
    ruleName: rule,
    route: RouteUrls.JobandTalent.CandidateList,
    dynamicParams: candidateListDynamicParams,
    paramMappings: candidateListParamMappings
  })),
  ...candidateDetailTask.map(rule => ({
    ruleName: rule,
    route: candidateDetailRoute,
    dynamicParams: candidateDetailDynamicParams,
    paramMappings: candidateDetailParamMappings
  }))
];

export const NotificationTabs: NotificationTabConfig[] = [
  {
    type: NotificationType.MyTasksPending,
    icon: 'Notification',
    labelKey: 'Notification.Tasks.PendingMyTasks',
    countKey: 'myTaskCount'
  },
  {
    type: NotificationType.MyTasks,
    icon: '',
    labelKey: 'Notification.Tasks.PendingTasks',
    countKey: 'taskCount'
  },
  {
    type: NotificationType.Texts,
    icon: 'emailenvelope',
    labelKey: 'Notification.Texts',
    countKey: 'textCount'
  },
  {
    type: NotificationType.Email,
    icon: 'UnReadEmail',
    labelKey: 'Notification.Emails',
    countKey: 'emailCount'
  }
];
